import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { OTPCheckDto } from '../../../dto/otp/otpcheck/otpcheckdto';

export interface OTPCheckResponse extends APIResponse 
{
    getOTPCheckDto(): OTPCheckDto;
}

export class OTPCheckResponseDtoImpl extends APIResponseDtoImpl implements OTPCheckResponse 
{
    private otpCheckResponseDto : OTPCheckDto;

    getOTPCheckDto(): OTPCheckDto
    {
        return this.otpCheckResponseDto;
    }
    setOTPCheckDto(otpCheckResponseDto: OTPCheckDto)
    {
        this.otpCheckResponseDto = otpCheckResponseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/otpcheck/otpcheckresponse.tsx